import CIMSFormItem from 'components/CIMSFormItem'
import GenericRequest from '../../../GenericRequest'
import CIMSDateRange from 'components/CIMSDateRange'
import { useCreationNotification } from '../../../GenericRequest/hooks/useCreationNotification'
import { useCreatePhotoExportRequestMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useGlobalState } from 'context/GlobalStateContext'
import { useState } from 'react'
import { Moment } from 'moment'
import { errorHandler } from 'hooks/errorHandler'

const Request: React.FC = () => {
  const created = useCreationNotification()
  const [create, { loading }] = useCreatePhotoExportRequestMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({ createPhotoExportRequest: { photoExportRequest } }) =>
      created(photoExportRequest, 'Photo Export Request'),
  })
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const [values, setValues] = useState<{
    createdDate: [Moment | null, Moment | null] | null
  }>({
    createdDate: [null, null],
  })
  return (
    <GenericRequest
      initialValues={values}
      onRequest={({ createdDate }) => {
        const [from, to] = createdDate ?? [null, null]
        setValues({ createdDate: [from, to] })
        if (!projectId) return errorHandler('projectId is not defined')
        create({
          variables: {
            createPhotoExportRequestInput: {
              // if dateRange is truthy then `from` and `to` must be present so using bang
              createdDate: { from: from!.toISOString(), to: to!.toISOString() },
              projectId,
            },
          },
        })
      }}
      estimatesAreCalculatedBy="multiplying the count of all photos created during the supplied range by the average time it takes to download and export one"
      request={{ name: 'Photo Export Request', type: 'photos' }}
      reduceEstimatesBy="adjusting the Created Date range below"
      loading={loading}
      errorMessagesInclude="helpful metadata about each failure which may help CIMS fix an unknown issue with the export. You may also use this information to download single photos with the Photo Viewer"
    >
      <CIMSFormItem
        name="createdDate"
        label="Created Date"
        help="Enter a date range based on when the photos were created"
        requiredMessage="Please enter a date range"
      >
        <CIMSDateRange />
      </CIMSFormItem>
    </GenericRequest>
  )
}

export default Request
